import { FC, ReactNode } from "react";

interface CaretPinnedMentionsListProps {
  children: ReactNode;
}

export const CaretPinnedMentionsList: FC<CaretPinnedMentionsListProps> = ({
  children,
}) => (
  <ul
    className="jugl__custom-scrollbar relative top-6 -left-2 z-[1000] m-0 flex max-h-[200px] w-[314px] flex-col gap-1 overflow-y-auto rounded-lg border border-solid border-dark-100 bg-white px-0 py-2"
    style={{ boxShadow: "0 9px 16px 0 rgba(18, 22, 34, 0.12)" }}
  >
    {children}
  </ul>
);
